import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.readAndThinkBonusLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.readAndThinkBonusLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.readAndThinkBonusLevels.data.readAndThinkBonusLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
